export default __webpack_public_path__ + "static/media/img_2.ba6cca94.png";